function getLunarPhaseName(phase) {
  switch (phase) {
    case 'New moon':
      return 'Новолуние';
    case 'Waxing crescent':
      return 'Растущая луна';
    case 'First quarter':
      return 'Первая четверть';
    case 'Waxing gibbous':
      return 'Растущий полумесяц';
    case 'Full':
      return 'Полнолуние';
    case 'Waning gibbous':
      return 'Убывающая луна';
    case 'Last quarter':
      return 'Последняя четверть';
    case 'Waning crescent':
      return 'Убывающий полумесяц';
    default:
      return phase;
  }
}


function getLunarZodiacName(zodiacName) {
  switch (zodiacName) {
    case 'Capricorn':
      return 'козероге';
    case 'Aquarius':
      return 'водолее';
    case 'Pisces':
      return 'рыбах';
    case 'Aries':
      return 'овне';
    case 'Taurus':
      return 'тельце';
    case 'Gemini':
      return 'близнецах';
    case 'Cancer':
      return 'раке';
    case 'Leo':
      return 'льве';
    case 'Virgo':
      return 'деве';
    case 'Libra':
      return 'весе';
    case 'Scorpio':
      return 'скорпионе';
    case 'Sagittarius':
      return 'стрельце';
    default:
      return '';
  }
}

moment.locale('ru')

function updateDateTime() {
  var now = moment(); // Получаем текущее время
  var elements = document.querySelectorAll('.js-current-datetime');

  // Обновляем innerText каждого элемента
  elements.forEach(function (element) {
    element.innerText = now.format('DD MMMM HH:mm:ss'); // Форматируем и выводим
  });
}

document.addEventListener('DOMContentLoaded', function () {
  var aosOffset = 110
  if (window.innerWidth < 768) {
    aosOffset = 50
  }
  AOS.init({
    // Global settings:
    disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
    startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
    initClassName: 'aos-init', // class applied after initialization
    animatedClassName: 'aos-animate', // class applied on animation
    useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
    disableMutationObserver: false, // disables automatic mutations' detections (advanced)
    debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
    throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)


    // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
    offset: aosOffset, // 120 offset (in px) from the original trigger point
    delay: 0, // values from 0 to 3000, with step 50ms
    duration: 1200, // values from 0 to 3000, with step 50ms
    easing: 'ease', // default easing for AOS animations
    once: false, // whether animation should happen only once - while scrolling down
    mirror: false, // whether elements should animate out while scrolling past them
    anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
  });

  // Обновляем дату и время каждые 1000 мс (1 секунда)
  setInterval(updateDateTime, 1000);

  // Вызываем функцию сразу, чтобы не ждать 1 секунду при загрузке
  updateDateTime();
});

var apiKey = "21b8b3da8dmsh61ec636f7065459p19d0f1jsnff5320e6c7a5";
var latitude = 55.755864;
var longitude = 37.617698;
var url = 'https://moon-phase.p.rapidapi.com/advanced'
// var yesterdayMoonData = null

function getStartAndEndMoonDay() {
  const requestOptions = {
    method: "GET",
    redirect: "follow"
  };

  const dateString = moment().add(1, 'day').format('YYYY-MM-DD');

  fetch("https://api.ipgeolocation.io/v2/astronomy?apiKey=ed080ecf91794238bea7e59d2f1e6d2a&location=Moscow", requestOptions)
    .then((response) => response.json())
    .then((result) => {
      console.log(result)

      $('.moon-day__value').append(`
        (с ${moment(result.astronomy.date, 'YYYY-MM-DD').format('DD.MM.YYYY')} ${result.astronomy.moonrise}
      `)

      fetch("https://api.ipgeolocation.io/v2/astronomy?apiKey=ed080ecf91794238bea7e59d2f1e6d2a&location=Moscow&date=" + dateString, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          console.log(result)

          $('.moon-day__value').append(`
            до ${moment(result.astronomy.date, 'YYYY-MM-DD').format('DD.MM.YYYY')} ${result.astronomy.moonrise})
          `)
        })
        .catch((error) => console.error(error));
    })
    .catch((error) => console.error(error));

}

$(document).ready(function () {
  // $.ajax({
  //   url: 'https://api.viewbits.com/v1/moonphase',
  //   method: "GET",
  //   success: function (response) {
  //     console.log(response)

  //     // var phaseInRussian = getLunarPhaseName(response.moon.phase_name);
  //     var zodiacNameInRussian = getLunarZodiacName(response.moon.zodiac.moon_sign);
  //     var stageName = response.moon.stage === 'waxing' ? 'с растущей Луной' : 'с убывающей Луной'
  //     var lunarPhaseEmoji = response.moon.emoji
  //     // var moonriseDate = moment.unix(response.moon.moonrise_timestamp);
  //     // var moonsetDate = moment.unix(response.moon.moonset_timestamp);
  //     var day = response.moon.age_days
  //     // var nextDayNumber = day === 30 ? 1 : (Number(day) + 1)




  //     // Лунный день сегодня - ${day} (восход: ${moonriseDate.format('DD.MM.YYYY HH:mm')}, закат: ${moonsetDate.format('DD.MM.YYYY HH:mm')} (мск)) <br>
  //     $('.moon-day__value').html(`
  //       Сейчас ${day} лунный день ${stageName} в ${zodiacNameInRussian} <br>
  //       Лунный день сегодня - ${day}
  //     `)
  //     // $('.moon-day-detail__title').text(`${day} лунный день`)
  //     $('.moon-day__descr').text(`${lunarPhaseEmoji}`)
  //     // $('.moon-day__set-rise').text(`Восход Луны в ${response.moon.moonrise}, а закат в ${response.moon.moonset}. Процент освещенности Луны: ${response.moon.illumination}.`)


  //     let moonDays = []

  //     // Вставьте этот код в ваш JavaScript файл
  //     fetch('/wp-json/wp/v2/moon_day?per_page=100')
  //       .then(response => response.json())
  //       .then(data => {
  //         moonDays = data.map(item => ({
  //           id: item.id,
  //           number: item.acf.number,
  //           title: item.title.rendered,
  //           content: item.content.rendered,
  //           image: item.featured_media.medium,
  //         }));
  //         var currentDay = moonDays.find(item => item.number === day)

  //         if (currentDay) {
  //           $('.js-moon-day-image').attr('src', currentDay.image)
  //           $('.moon-day__text').html(currentDay.content)
  //         }
  //       })
  //       .catch(error => console.error('Ошибка:', error));
  //   },
  //   error: function (xhr, status, error) {
  //     console.error("Ошибка:", error);
  //   }
  // });

  // getStartAndEndMoonDay()
});